import API from '../../../api/API';

export default class ReportsAPI extends API {
  constructor(parameters = {}) {
    super("/Report", parameters);
  }

  getReportBasedOnExpenses(data) {
    return this.submit('post', `${this.endpoint}/ReportBasedOnExpenses`, data);
  }

  getDecryptionReportBasedOnAssets(data) {
    return this.submit('post', `${this.endpoint}/DecryptionReportBasedOnAssets`, data);
  }

  getDecryptionReportBasedOnExpenses(data) {
    return this.submit('post', `${this.endpoint}/DecryptionReportBasedOnExpenses`, data);
  }

  getDecryptionReportBasedOnAssetsAndExpenses(data) {
    return this.submit('post', `${this.endpoint}/DecryptionReportBasedOnAssetsAndExpenses`, data);
  }

  getSummaryReportForContractsWithSimplification(data) {
    return this.submit('post', `${this.endpoint}/SummaryReportForContractsWithSimplification`, data);
  }

  getSummaryReportBasedOnLiabilities(data) {
    return this.submit('post', `${this.endpoint}/SummaryReportBasedOnLiabilities`, data);
  }

  getSummaryReportBasedOnCashOutflows(data) {
    return this.submit('post', `${this.endpoint}/SummaryReportBasedOnCashOutflows`, data);
  }

  getSummaryReportBasedOnLiabilitiesMaturity(data) {
    return this.submit('post', `${this.endpoint}/SummaryReportBasedOnLiabilitiesMaturity`, data);
  }

  exportExportResultOfReportBasedOnExpenses(data) {
    return this.export('post', `${this.endpoint}/ExportResultOfReportBasedOnExpenses`, data);
  }

  exportResultOfDecryptionReportBasedOnAssets(data) {
    return this.export('post', `${this.endpoint}/ExportResultOfDecryptionReportBasedOnAssets`, data);
  }

  exportResultOfDecryptionReportBasedOnExpenses(data) {
    return this.export('post', `${this.endpoint}/ExportResultOfDecryptionReportBasedOnExpenses`, data);
  }

  exportResultOfDecryptionReportBasedOnAssetsAndExpenses(data) {
    return this.export('post', `${this.endpoint}/ExportResultOfDecryptionReportBasedOnAssetsAndExpenses`, data);
  }

  exportResultOfSummaryReportForContractsWithSimplification(data) {
    return this.export('post', `${this.endpoint}/ExportResultOfSummaryReportForContractsWithSimplification`, data);
  }

  exportResultOfSummaryReportBasedOnLiabilities(data) {
    return this.export('post', `${this.endpoint}/ExportResultOfSummaryReportBasedOnLiabilities`, data);
  }

  exportResultOfSummaryReportBasedOnCashOutflows(data) {
    return this.export('post', `${this.endpoint}/ExportResultOfSummaryReportBasedOnCashOutflows`, data);
  }

  exportResultOfSummaryReportBasedOnLiabilitiesMaturity(data) {
    return this.export('post', `${this.endpoint}/ExportResultOfSummaryReportBasedOnLiabilitiesMaturity`, data);
  }

  downloadResultOfReportBasedOnExpenses(data) {
    return this.export('post', `${this.endpoint}/DownloadResultOfReportBasedOnExpenses`, data);
  }

  downloadResultOfDecryptionReportBasedOnAssets(data) {
    return this.export('post', `${this.endpoint}/DownloadResultOfDecryptionReportBasedOnAssets`, data);
  }

  downloadResultOfDecryptionReportBasedOnExpenses(data) {
    return this.export('post', `${this.endpoint}/DownloadResultOfDecryptionReportBasedOnExpenses`, data);
  }

  downloadResultOfDecryptionReportBasedOnAssetsAndExpenses(data) {
    return this.export('post', `${this.endpoint}/DownloadResultOfDecryptionReportBasedOnAssetsAndExpenses`, data);
  }

  downloadResultOfReportOfMovementGuaranteePayments(data) {
    return this.export('post', `${this.endpoint}/DownloadResultOfReportOfMovementGuaranteePayments`, data);
  }

  downloadResultOfSummaryReportForContractsWithSimplification(data) {
    return this.export('post', `${this.endpoint}/DownloadResultOfSummaryReportForContractsWithSimplification`, data);
  }

  downloadResultOfSummaryReportBasedOnLiabilities(data) {
    return this.export('post', `${this.endpoint}/DownloadResultOfSummaryReportBasedOnLiabilities`, data);
  }

  downloadResultOfSummaryReportBasedOnCashOutflows(data) {
    return this.export('post', `${this.endpoint}/DownloadResultOfSummaryReportBasedOnCashOutflows`, data);
  }

  downloadResultOfSummaryReportBasedOnLiabilitiesMaturity(data) {
    return this.export('post', `${this.endpoint}/DownloadResultOfSummaryReportBasedOnLiabilitiesMaturity`, data);
  }

  downloadResultOfSummaryFuturePaymentsForReports(data) {
    return this.export('post', `${this.endpoint}/DownloadResultOfSummaryFuturePaymentsForReports`, data);
  }

  downloadResultOfReportQuarterlyAccrualCurrentLiabilities(data) {
    return this.export('post', `${this.endpoint}/DownloadResultOfReportQuarterlyAccrualCurrentLiabilities`, data);
  }

  getReportBasedOnEvents(data) {
    return this.export('post', `${this.endpoint}/DownloadReportBasedOnEvents`, data);
  }
}
